import { render } from "./NewAside.vue?vue&type=template&id=f40263c4"
import script from "./NewAside.vue?vue&type=script&lang=js"
export * from "./NewAside.vue?vue&type=script&lang=js"

import "./NewAside.vue?vue&type=style&index=0&id=f40263c4&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__